<template>
    <div>
        <el-row>
            <el-col :span="8">
                <el-button type="primary" @click="openUploadFile">打开上传图片</el-button>
            </el-col>
            <el-col :span="16" v-if="isSelect">
                <img :src="site" width="120" height="80" class="head_pic" v-for="site in selectImagesComputed" v-if="site"/>

                <img :src="this.msg" width="120" height="120" class="head_pic" v-if="selectImages==''" v-show="this.msg"/>
            </el-col>
        </el-row>
        <picDialog :fromState="fromState" :picType="activeNo" @selectPicOne="selectPicOne"></picDialog>

        <el-dialog title="图片管理" :visible.sync="dialogFormVisibleUpload" center append-to-body>
            <el-form :model="openUploadForm" label-width="120px">
                <el-form-item label="分组类型">
                    <el-select v-model="openUploadForm.typeId" filterable @change="handChangeList">
                        <el-option
                                v-for="item in getImageTypeList"
                                :key="item.typeId"
                                :label="item.typeName"
                                :value="item.typeId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="图片描述">
                    <el-input v-model="openUploadForm.imageName" placeholder="请先输入图片描述"></el-input>
                    <span style="color: red">*必填</span>
                </el-form-item>
                <el-form-item label="上传图片">
                    <el-upload
                            multiple
                            :data="openUploadForm"
                            :with-credentials="true"
                            :show-file-list="false"
                            class="upload-demo"
                            :action="saveUploadPath"
                            :on-success="uploadSuccess"
                            :before-upload="uploadBefore">
                        <el-button size="small" type="primary">点击上传</el-button>图片大小尽量不超过500k
                    </el-upload>
                </el-form-item>
                <el-form-item label="选择的图片" v-if="isSelect">
                    <el-row>
                        <el-col :span="18">
                            <img :src="site" width="120" height="80" class="head_pic" v-for="site in selectImagesArray"/>
                        </el-col>
                        <el-col :span="6">
                            <el-button size="small"  type="success" @click="closeUploadFile">确认选择</el-button>
                        </el-col>
                    </el-row>
                </el-form-item>
            </el-form>
            <el-table ref="multipleTableupload" :data="getImageList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading" @selection-change="handleSelectionChangeUpload">
                <el-table-column type="selection" width="55" v-if="isSelect"></el-table-column>
                <el-table-column type="index" label="序号" width="60"></el-table-column>
                <el-table-column prop="imageName" label="图片描述" sortable></el-table-column>
                <el-table-column prop="imagePath" label="图片路径" sortable></el-table-column>
                <el-table-column label="图片路径" >
                    <template  slot-scope="scope">
                        <img :src="scope.row.allImagePath" width="120" height="60" class="head_pic"/>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="80">
                    <template slot-scope="scope">
                        <el-button type="warning " size="mini" @click="deleteImage(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        background
                        @size-change="handleSizeChangeUpload"
                        @current-change="handleCurrentChangeUpload"
                        :current-page="openUploadForm.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="openUploadForm.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="openUploadForm.recordsTotal">
                </el-pagination>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {getImageTypeList, getImageList, saveImagepth, deleteImage} from '../api/api'
    import picDialog from '@/components/pic_dialog/pic_list'

    //定义组件
    export default {
        model: {
            prop: 'msg',
            event: 'cc'
        },
        props:{
            msg: {

            },
            selectSize: {
                default: 1
            },
            isSelect: {
                default: true
            },
            groupId:{
                default: ''
            },
            urlType:{
                default: 1
            },
            selectImages:{
                default:''
            },
            fromState:{
                default:''
            }
        },
        data() {
            return {
                getImageList: [],
                getImageTypeList: [],
                loading: true,
                dialogFormVisibleUpload: false,
                openUploadForm: {
                    typeId: "",
                    imageName: "",
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0,
                },
                saveUploadPath: saveImagepth,
                imageUrlsBak:'',
                imageAllUrlsBak:'',
                selectImagesArray:[],

                activeNo:''
            }
        },
        components:{picDialog},
        //挂载时候执行
        mounted() {
            //获取查询条件下拉列表
            getImageTypeList({}).then((res) => {
                this.getImageTypeList = res.data;
                this.openUploadForm.typeId = this.getImageTypeList[0].typeId;
                this.getUploadList();
            });
        },
        computed: {
            selectImagesComputed:function() {
                if(this.selectImages!=''){
                    return this.selectImages.split(',');
                }
                return [];
            }
        },
        methods: {
            openUploadFile() {
                if(this.groupId!=''){
                    this.openUploadForm.typeId=this.groupId;
                }
                this.getUploadList();
                // this.dialogFormVisibleUpload = true;
                this.$store.commit('SET_PIC_DIALOG',true)
                this.$emit('showSelectPic',false)
            },
            closeUploadFile(){
                if(this.urlType==1){
                    this.$emit('cc', this.imageUrlsBak);
                }else{
                    this.$emit('cc', this.imageAllUrlsBak);
                }
                this.$emit("on-result-change",this.imageAllUrlsBak);
                this.dialogFormVisibleUpload = false;
            },
            handChangeList(){
                this.getUploadList();
            },
            //定义查询方法
            getUploadList() {
                this.loading = true;
                getImageList(this.openUploadForm).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '查询成功',
                            type: 'success'
                        });
                        this.openUploadForm.recordsTotal = res.data.value.total;
                        this.getImageList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleSizeChangeUpload(val) {
                this.openUploadForm.pageSize = val;
                this.getUploadList()
            },
            handleCurrentChangeUpload(val) {
                this.openUploadForm.currentPage = val;
                this.getUploadList()
            },
            uploadBefore(){
                if(this.openUploadForm.typeId==0){
                    this.$message({
                        showClose: true,
                        message: '请选择要上传的图片具体类型',
                        type: 'error'
                    });
                    return;
                }
                const loading = this.$loading(this.GCONFIG.loadingParam);
            },
            uploadSuccess(res) {
                const loading = this.$loading(this.GCONFIG.loadingParam);
                loading.close();
                if (res.status == 200) {
                    this.$notify({
                        title: '成功',
                        message: '上传成功',
                        type: 'success'
                    });
                    this.dialogFormVisible = false;
                    this.getUploadList();
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: 'error'
                    });
                }
            },
            deleteImage(row) {
                this.$confirm('删除图片, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const loading = this.$loading(this.GCONFIG.loadingParam);
                    deleteImage({imageId: row.imageId}).then((res) => {
                        loading.close();
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getUploadList();
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {
                });
            },
            handleSelectionChangeUpload(val) {
                if(this.selectSize!=undefined&&val.length>this.selectSize){
                    this.$message({
                        showClose: true,
                        message: "选择图片超出限定长度，最多能选择"+this.selectSize+"张",
                        type: 'error'
                    });
                    this.$refs.multipleTableupload.clearSelection();
                    return ;
                }
                var arrs=[];
                var arrs_all=[];
                val.forEach(row => {
                    arrs.push(row.imagePath);
                    arrs_all.push(row.allImagePath)
                });
                this.selectImagesArray=arrs_all;
                this.imageUrlsBak = arrs.join(',');
                this.imageAllUrlsBak=arrs_all.join(',');
            },
            selectPicOne(obj){
                console.log(obj)
                this.$store.commit('SET_PIC_DIALOG',false)
                this.$emit('selectPicOne',obj)
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/upload.vue